
(function () {
    const GRID_SELECTOR = '.custom-article-grid-sec';
    const CARD_SELECTOR = '[data-equal-height-card]';
    let resizeTimer;

    function equalizeGridHeights() {
        const grids = document.querySelectorAll(GRID_SELECTOR);
        if (!grids.length) return;

        grids.forEach(grid => {
            const cards = grid.querySelectorAll(CARD_SELECTOR);
            if (!cards.length) return;

            // Reset heights first
            cards.forEach(card => {
            card.style.minHeight = 'auto';
            });

            // Find max height
            let maxHeight = 0;
            cards.forEach(card => {
            const height = card.offsetHeight;
            if (height > maxHeight) maxHeight = height;
            });

            // Apply max height
            cards.forEach(card => {
            card.style.minHeight = `${maxHeight}px`; // <- must be inside the forEach
            });
        });
        }


    // Run after everything loads (images included)
    window.addEventListener('load', equalizeGridHeights);

    // Resize-safe (debounced)
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalizeGridHeights, 150);
    });

    // Shopify section support
    document.addEventListener('shopify:section:load', equalizeGridHeights);
    console.log(card.dataset.equalHeightCard); // returns value or "" if no value

})();
